module.exports = __webpack_public_path__ + "img/optimy-logo.bf136871.png";